import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Capture the promotion deep-link intent as early as possible — before React
// mounts or any LIFF login redirect can fire — so it survives a first-login
// round-trip. UserHeader consumes this flag once the user is authenticated.
try {
  const p = new URLSearchParams(window.location.search);
  if (p.get('promo') === '1' || p.get('topup') === '1') {
    window.sessionStorage.setItem('pendingPromo', '1');
  }
} catch (_) {}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
